import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace RadiusServerValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
